module.exports = __webpack_public_path__ + "img/floor_UG1.eac4bd64.svg";